import { Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';

export function DdsNumber({ label, value }: { label: string; value: string }) {
  const { t } = useTranslation('transits');

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(t('ddsNumberCopied'));
    } catch {
      toast.error(t('ddsNumberCopyError'));
    }
  };

  return (
    <div>
      <dt className='text-muted-foreground text-xs'>{label}</dt>
      <dd className='flex items-center gap-1'>
        <span className='select-all break-all font-mono'>{value}</span>
        <Button
          aria-label={t('ddsCopyNumber', { label })}
          onClick={copy}
          size='icon'
          type='button'
          variant='ghost'
        >
          <Copy aria-hidden className='size-4' />
        </Button>
      </dd>
    </div>
  );
}
